<div #googleMap class="googleMap"></div>
<mat-card appearance="outlined" id="toggles">
  <mat-slide-toggle (change)="toggleTraffic($event)"><mat-icon>directions_car</mat-icon></mat-slide-toggle>
  <mat-slide-toggle (change)="toggleSatellite($event)"><mat-icon>layers</mat-icon></mat-slide-toggle>
</mat-card>
